










import Vue from "vue";
import { loadScript } from "@/utils/loadScript";

export default Vue.extend({
  name: "Video",
  data() {
    return {
      player: null,
      wplayer_js: "//s1.hdslb.com/bfs/static/player/main/html5/wplayer.js?t=" + Math.ceil(Date.now() / 600000),
      bvid: "BV1TG411K7A7"
    };
  },
  mounted() {
    loadScript(this.wplayer_js).then(() => {
      const wrap = document.getElementById("player");
      const bvid = this.bvid;
      // @ts-ignore
      const player = new WPlayer({
        wrap,
        bvid,
        noFullScreenButton: true
      });
      this.player = player;
    });
  },
  beforeDestroy() {
    if (this.player) {
      // @ts-ignore
      this.player.dispose();
    }
  }
});
